import { render } from "./PlacementSettingContainer.vue?vue&type=template&id=4513fd21&scoped=true&ts=true"
import script from "./PlacementSettingContainer.vue?vue&type=script&lang=ts"
export * from "./PlacementSettingContainer.vue?vue&type=script&lang=ts"

import "./PlacementSettingContainer.vue?vue&type=style&index=0&id=4513fd21&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4513fd21"]])

export default __exports__